import React from 'react';
import PropTypes from "prop-types";
import intl from "react-intl-universal";
import Button from '../../components/Common/Button';
import common from '../../common/common';
import {Commun, toast} from '../../utils/axios';
import _ from 'lodash';
import styles from './index.module.scss';

class Address extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '', // 收货人姓名
            phone: '', // 联系人电话
            isEncrypt: true, // 电话号码是否加密
            address: '' // 收货地址
        };

        this.debounceSaveAddress =  _.debounce(this.onSaveAddress, 1000, { leading: true, trailing: false });
    }

    static defaultProps = {
        name: '',
        phone: '',
        address: '',
        showOkBtn: true,
        onSuccess: null,
        showCancelBtn: true,
        onCancel: null,
    };

    static propTypes = {
        name: PropTypes.string, // 收货人姓名
        phone: PropTypes.string, // 联系人电话
        address: PropTypes.string, // 收货地址
        showOkBtn: PropTypes.bool, // 是否展示确定按钮
        onSuccess: PropTypes.func, // 保存成功后的回调
        showCancelBtn: PropTypes.bool, // 是否展示取消按钮
        onCancel: PropTypes.func // 点击取消按钮后的回调
    };

    componentDidMount() {
        // 地址页面
    }

    componentDidUpdate(prevProps, prevState) {
        const { name, phone, address } = this.props;
        if (name !== prevProps.name) {
            this.setState({
                name
            })
        }
        if (phone !== prevProps.phone) {
            this.setState({
                phone
            })
        }
        if (address !== prevProps.address) {
            this.setState({
                address
            })
        }
    }

    // 重置数据
    resetData = () => {
        const { name, phone, address } = this.props;
        this.setState({
            name,
            phone,
            address,
            isEncrypt: true
        })
    };

    // value值改变
    onValueChange = (key, e) => {
        let { value } = e.target;
        switch(key) {
            case 'name':
                value = value.substring(0, 100);
                break;
            case 'address':
                value = value.substring(0, 200);
                break;
        }
        this.setState({
            [key]: value
        });
    };

    // 聚焦
    onFocus = (key, e) => {
        switch(key) {
            case 'phone':
                this.setState({
                    isEncrypt: false
                });
                break;
        }

    };

    // 失焦
    onBlur = (key, e) => {
        const { value } = e.target;
        this.setState({
            [key]: value.trim()
        });
    };

    /**
     * 手机号中间4位加密
     * @param phone {String} 手机号码
     */
    encryptPhoneNumber = (phone) => {
        return phone.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
    };

    // 点击取消按钮
    onCancel = () => {
        this.resetData();
        typeof this.props.onCancel === 'function' && this.props.onCancel();
    };

    // 点击确定按钮
    onSaveAddress = async () => {
        if (!this.check()) return;

        try {
            let response = await this.saveAddress();
            this.setState({
                isEncrypt: true
            });
            typeof this.props.onSuccess === 'function' && this.props.onSuccess();
        } catch(error) {
            console.log(error);
        }
    };

    // 校验填写内容
    check = () => {
        const { name, phone, address } = this.state;
        if (!name) {
            toast(intl.get('ENTER_CONSIGNEE'));
            return false;
        }
        if (!phone) {
            toast(intl.get('ENTER_TELEPHONE_NUMBER'));
            return false;
        }
        if (!/^[1][0-9]{10}$/.test(phone)) {
            toast(intl.get('ENTER_CORRECT_TELEPHONE_NUMBER'));
            return false;
        }
        if (!address) {
            toast(intl.get('ENTER_MAIL_ADDRESS'));
            return false;
        }

        return true;
    };

    // 保存信息
    saveAddress = () => {
        const { name, phone, address } = this.state;
        return Commun.post(`${common.userApiPrefix}/address`, {
            consignee: name,
            phone,
            address
        });
    };


    render() {
        const {
            name,
            phone,
            isEncrypt,
            address
        } = this.state;

        const {
            showOkBtn,
            showCancelBtn
        } = this.props;

        return (
            <div className={styles.addressContainer}>
                <div className={styles.addressWrap}>
                    <div className={styles.info}>
                        <dl className={styles.addressItem}>
                            <dt>{`${intl.get('CONSIGNEE')}${common.isMobile() ? '' : '：'}`}</dt>
                            <dd>
                                <input
                                    type="text"
                                    placeholder={intl.get('ENTER_CONSIGNEE')}
                                    value={name}
                                    onChange={(e) => this.onValueChange('name', e)}
                                    onBlur={(e) => this.onBlur('name', e)}
                                />
                            </dd>
                        </dl>
                        <dl className={styles.addressItem}>
                            <dt>{`${intl.get('TELEPHONE_NUMBER')}${common.isMobile() ? '' : '：'}`}</dt>
                            <dd>
                                <input
                                    type="text"
                                    placeholder={intl.get('ENTER_TELEPHONE_NUMBER')}
                                    maxLength={11}
                                    value={isEncrypt ? this.encryptPhoneNumber(phone) : phone}
                                    onChange={(e) => this.onValueChange('phone', e)}
                                    onFocus={(e) => this.onFocus('phone', e)}
                                    onBlur={(e) => this.onBlur('phone', e)}
                                />
                            </dd>
                        </dl>
                        <dl className={styles.addressItem}>
                            <dt>{`${intl.get('MAIL_ADDRESS')}${common.isMobile() ? '' : '：'}`}</dt>
                            <dd>
                                {
                                    common.isMobile() ?
                                        <input
                                            type="text"
                                            placeholder={intl.get('ENTER_MAIL_ADDRESS')}
                                            value={address}
                                            onChange={(e) => this.onValueChange('address', e)}
                                            onBlur={(e) => this.onBlur('address', e)}
                                        /> :
                                        <textarea
                                            placeholder={intl.get('ENTER_MAIL_ADDRESS')}
                                            value={address}
                                            onChange={(e) => this.onValueChange('address', e)}
                                            onBlur={(e) => this.onBlur('address', e)}
                                        />
                                }
                            </dd>
                        </dl>
                    </div>
                    <div className={styles.tips}>{intl.get('ADDRESS_STATEMENT')}</div>
                </div>
                <ul className={styles.btnList}>
                    {
                        showCancelBtn &&
                            <li>
                                <Button
                                    size={common.isMobile() ? 'large' : 'default'}
                                    type={common.isMobile() ? 'default' : 'warn'}
                                    onClick={this.onCancel}
                                >{intl.get('CANCEL_TEXT')}</Button>
                            </li>
                    }
                    {
                        showOkBtn &&
                        <li>
                            <Button
                                size={common.isMobile() ? 'large' : 'default'}
                                type="primary"
                                onClick={this.debounceSaveAddress}
                            >{intl.get('SAVE_TEXT')}</Button>
                        </li>
                    }
                </ul>
            </div>
        )
    }
}
export default Address;